import { useState } from "react";
import "./Login.css";
import LoginFieldFirst from "./Components/LoginFieldFirst";
import LoginFieldSecond from "./Components/LoginFieldSecond";
import { AddToastNotification } from "../../Services/ToastNotification/ToastNotificationManager";

const Login = ({setLogged}) =>
{ 
  const [codeId, setCodeId] = useState("");
  const [step, setStep] = useState(0);

  const onSuccessFirstStep = (codeId) => {
    setCodeId(codeId);
    setStep(1);
  }
  const OnFail = (message) => {
    console.log("fail", message);
    AddToastNotification(message, 0);
  }

  const onLogged = () => {
    setLogged(true);
  }

  return (
    <div className="content center-content">
      <div className="loginForm center-content">
        <div className="logotype center-content">
          <img src="../images/svg/netraLogo.svg" className="size-20 m-2"/>
          <span className="text-4xl font-light">Netra Panel</span>
        </div>
        <span className="text-2xl mb-8">Zaloguj się</span>
        { step == 0 &&
           <LoginFieldFirst onSuccess={onSuccessFirstStep} OnFail={OnFail}/>
        }
        { step == 1 &&
           <LoginFieldSecond backToFirstStep={() => setStep(0)} codeId={codeId} onLogged={onLogged} OnFail={OnFail}/>
        }
      </div>
    </div>
  );
  
}

export default Login;